import React from 'react';
import {
  Checkbox, IconButton, ListIcon, Menu, Pane, Popover, Position, SearchInput, Text, Tooltip,
} from 'evergreen-ui';

/**
 *
 * @param {array} options Данные для отображения всех элементов [{label, value}]
 * @param {array} selectedItems Выбранные элементы в меню
 * @param {function} setSelectedItems Установка выбранных элементов
 * @param {string} tooltip Tooltip над кнопкой
 * @param icon
 * @param intent
 * @param appearance
 * @param oneRequired
 * @returns SelectMenu с параметрами Checkbox
 * @example <CheckboxList
 options={errorStatuses.map(({ id, status }) => ({ label: status, value: id }))}
 selectedItems={filterStatuses}
 setSelectedItems={setFilterStatuses}
 tooltip="Выборка типов ошибок"
 />
 */
export default function CheckboxList({
  options = [],
  selectedItems = [],
  setSelectedItems = () => { },
  tooltip,
  icon,
  intent,
  appearance,
  oneRequired,
}) {
  const [searchText, setSearchText] = React.useState('');
  const [width, setWidth] = React.useState(null);
  const ref = React.useRef(null);
  // показывает строку поиска и checkbox Выбрать/Убрать все, если элементов больше 5
  const showHeader = React.useMemo(() => options.length > 5, [options]);
  // устанавливает/снимает все чекбоксы
  const onChangeAll = React.useCallback((e) => {
    const { checked } = e.target;
    if (checked) setSelectedItems(options);
    else setSelectedItems((cur) => (oneRequired ? [cur[0]] : []));
  }, [oneRequired, options, setSelectedItems]);

  // фильтрация по поисковой строке
  const filterOptions = React.useMemo(() => options.filter(({ label }) => label.toUpperCase().includes(searchText.toUpperCase())), [options, searchText]);

  // изменение чекбокса
  const onChange = React.useCallback((e, value) => {
    const { checked } = e.target;
    setSelectedItems((cur) => {
      let tmp = JSON.parse(JSON.stringify(cur));
      if (checked) {
        tmp = [...cur, options.find((op) => op.value === value)];
      } else {
        const index = tmp.findIndex((a) => a.value === value);
        tmp.splice(index, 1);
      }
      return tmp;
    });
  }, [options, setSelectedItems]);

  // Проверка, disabled для Checkbox
  const isDisable = React.useCallback((label, value) => oneRequired && (selectedItems.length === 1 && !!selectedItems.find((i) => i.label === label && i.value === value)), [oneRequired, selectedItems]);

  const labelWithAdditionalInfo = (label, additional, isProgram) => {
    if (!additional) return label;
    // TODO: допилить до красоты
    const Icons = () => additional?.icons?.map(({ icon: Icon, text, color }) => (
      <Tooltip content={text} key={text}>
        <Icon color={color} appearance="minimal" />
      </Tooltip>
    ));
    return (
      <Pane display="grid" gridTemplateColumns="repeat(3,max-content) 1fr" columnGap=".5em" alignItems="center">
        <Icons />
        <Tooltip content={isProgram ? 'Из программы наблюдений' : 'Не из программы наблюдений'}>
          {isProgram ? <b>[ПН]</b> : <s><b>[ПН]</b></s>}
        </Tooltip>
        <Text>{label}</Text>
      </Pane>
    );
  };

  return (
    <Popover
      position={Position.BOTTOM_RIGHT}
      minWidth={width}
      onOpenComplete={() => {
        // TODO: КОСТЫЛЬ ДО ЛУЧШИХ ВРЕМЕН. Не работает без setTimeout
        // работает
        // setTimeout(() => {
        const elem = document.getElementById('el1');
        setWidth(getComputedStyle(elem).width);
        // }, 1);
      }}
      content={(
        <Pane margin={16} id="el1">

          {
            showHeader && (
              <>
                <Checkbox
                  label="Выбрать/убрать все"
                  checked={options.length === selectedItems.length}
                  onChange={onChangeAll}
                />
                <SearchInput
                  marginBottom={5}
                  placeholder="Поиск..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  width="100%"
                />
                <Menu.Divider />
              </>
            )
          }
          <Pane maxHeight={300} overflow="auto" ref={ref}>
            {filterOptions?.map(({ label, value, additional, isProgram }) => (
              <Checkbox
                alignItems="center"
                disabled={isDisable(label, value)}
                key={value}
                label={labelWithAdditionalInfo(label, additional, isProgram)}
                checked={!!selectedItems.find((a) => a.value === value)}
                onChange={(e) => onChange(e, value)}
              />
            ))}
          </Pane>

        </Pane>
      )}
    >
      {tooltip ? (
        <Tooltip content={tooltip} position={Position.TOP}>
          <IconButton disabled={!options.length} icon={icon || ListIcon} intent={intent} appearance={appearance} />
        </Tooltip>
      )
        : <IconButton disabled={!options.length} icon={icon || ListIcon} intent={intent} appearance={appearance} />}
    </Popover>

  );
}
CheckboxList.defaultProps = {
  intent: 'success',
  appearance: 'primary',
  oneRequired: true,
};
